/* global document */

import { useCallback, useEffect, useRef } from 'react'

const MEDIA_FORMAT_ELEMENTS = {
  audio: 'audio',
  video: 'video',
}

export function useMediaDurationLoader(
  media,
  mediaFormat,
  onMediaDurationLoad,
) {
  const mediaLoaderRef = useRef()

  const onLoadedMetadata = useCallback(() => {
    if (mediaLoaderRef.current) {
      if (mediaLoaderRef.current.duration === Infinity) {
        mediaLoaderRef.current.currentTime = 1000
      }
    }
  }, [mediaLoaderRef])

  const onTimeUpdate = useCallback(() => {
    if (mediaLoaderRef.current) {
      if (
        mediaLoaderRef.current.currentTime > 0 &&
        mediaLoaderRef.current.duration !== Infinity
      ) {
        onMediaDurationLoad(mediaLoaderRef.current.duration)

        mediaLoaderRef.current.currentTime = 0
        mediaLoaderRef.current.src = null
      }
    }
  }, [onMediaDurationLoad, mediaLoaderRef])

  useEffect(() => {
    if (MEDIA_FORMAT_ELEMENTS[mediaFormat]) {
      mediaLoaderRef.current = document.createElement(
        MEDIA_FORMAT_ELEMENTS[mediaFormat],
      )
      mediaLoaderRef.current.addEventListener(
        'loadedmetadata',
        onLoadedMetadata,
      )
      mediaLoaderRef.current.addEventListener('timeupdate', onTimeUpdate)
      mediaLoaderRef.current.src = media
    }

    return () => {
      if (mediaLoaderRef.current) {
        mediaLoaderRef.current.removeEventListener(
          'loadedmetadata',
          onLoadedMetadata,
        )
        mediaLoaderRef.current.removeEventListener('timeupdate', onTimeUpdate)
        mediaLoaderRef.current.src = null
        mediaLoaderRef.current = null
      }
    }
  }, [media, mediaFormat, onLoadedMetadata, onTimeUpdate, mediaLoaderRef])
}
